  // To power the recently viewed products section, we save the ID of the product inside the local storage
  (() => {
    let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes()) {
      items.unshift();
    }

    // Then, we save the current product into the local storage, by keeping only the 8 most recent
    try {
      localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  })();
  let oldHref = window.location.href
  let variant = oldHref?.split('variant=')?.[1]?.split('&')?.[0] || null

  function showBadge (variant) {
    let els = document.querySelectorAll('.variant-badge')
    for (const el of els) {
      el.style.display = 'none'
      if (el.id === `${variant}-badge`) {
        console.log('here')
        el.style.display = 'unset'
      }
    }
  }
  setInterval(() => {
    const newHref = window.location.href

    if (newHref !== oldHref) {
      oldHref = newHref
      variant = oldHref?.split('variant=')?.[1]
      showBadge(variant)
    }
  }, 333)
  document.onreadystatechange = () => {
    showBadge(variant)
  }
